import { lazy } from 'react';

const PurchaseOrdersPage = lazy(() => import('../pages/PurchaseOrders.page'));
const AddPurchaseOrderPage = lazy(() => import('../pages/AddPurchaseOrder.page'));
const EditPurchaseOrderPage = lazy(() => import('../pages/EditPurchaseOrder.page'));
const CompaniesAndSuppliersPage = lazy(() => import('../pages/CompaniesAndSuppliers.page'));
const AddCompanySupplierPage = lazy(() => import('../pages/AddCompanySupplier.page'));
const EditCompanySupplierPage = lazy(() => import('../pages/EditCompanySupplier.page'));
const PurchaseReportsPage = lazy(() => import('../pages/PurchaseReports.page'));

const PurchaseOrdersRoutes = [
    {
        path: '/purchase-orders',
        element: <PurchaseOrdersPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/purchase-orders/add',
        element: <AddPurchaseOrderPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/purchase-orders/:id/edit',
        element: <EditPurchaseOrderPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/companies-and-suppliers',
        element: <CompaniesAndSuppliersPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/companies-and-suppliers/add',
        element: <AddCompanySupplierPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/companies-and-suppliers/:id/edit',
        element: <EditCompanySupplierPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/purchase-reports',
        element: <PurchaseReportsPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { PurchaseOrdersRoutes };
